import styled from 'styled-components'

const MultiTypeListStyle = styled.div`
    --mtlTitleMarginBottom: var(--sp8x);
    --mtlTitleWithCatMarginBottom: var(--sp5x);
    --mtlCatMarginBottom: var(--sp8x);
    --mtlCatItemMarginH: var(--sp1-5x);
    --mtlLoadMoreBtnMarginTop: var(--sp8x);

    display: flex;
    flex-direction: column;

    &.has-categories {
        --mtlTitleMarginBottom: var(--mtlTitleWithCatMarginBottom);
    }

    .mtl-cat-container {
        margin-top: calc(-1 * var(--mtlCatItemMarginH));
        margin-left: calc(-1 * var(--mtlCatItemMarginH)); 
        margin-right: calc(-1 * var(--mtlCatItemMarginH)); 
        margin-bottom: calc(var(--mtlCatMarginBottom) - var(--mtlCatItemMarginH));

        .mtl-cat-item {
            margin: var(--mtlCatItemMarginH) var(--mtlCatItemMarginH);
        }
    }

    .mtl-title {
        margin-bottom: var(--mtlTitleMarginBottom);
    }

    .mtli-container {
        > .row {
            margin-top: calc(-1 * var(--colPadding));
            margin-bottom: calc(-1 * var(--colPadding));

            .mtli-col {
                margin: var(--colPadding) 0;
            }
        }
    }

    .mtl-load-more-btn {
        align-self: center;
        margin-top: var(--mtlLoadMoreBtnMarginTop);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --mtlTitleMarginBottom: var(--sp7x);
        --mtlTitleWithCatMarginBottom: var(--sp4x);
        --mtlCatMarginBottom: var(--sp7x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp7x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --mtlTitleMarginBottom: var(--sp6x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp6x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp6x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --mtlTitleMarginBottom: var(--sp6x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp6x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp6x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --mtlTitleMarginBottom: var(--sp5x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp5x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp5x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --mtlTitleMarginBottom: var(--sp5x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp5x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp5x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --mtlTitleMarginBottom: var(--sp5x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp5x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp5x);
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --mtlTitleMarginBottom: var(--sp4x);
        --mtlTitleWithCatMarginBottom: var(--sp3x);
        --mtlCatMarginBottom: var(--sp4x);
        --mtlCatItemMarginH: var(--sp1x);
        --mtlLoadMoreBtnMarginTop: var(--sp4x);
    }
`

export default MultiTypeListStyle